import { css } from 'styled-components';

const Required = () => (
  <span title={I18n.t('views.backoffice.required')}> *</span>
);

export const AbbrRequired = () => (
  <abbr
    title={I18n.t('views.backoffice.required')}
    css={css`
      margin-left: 5px;
    `}
  >
    *
  </abbr>
);

export default Required;
